import { create } from './create';

export const query = {
  create,
};
